module.exports = __webpack_public_path__ + "static/media/spinnerLoadingBig.dfe32370.png";